import { Injectable } from '@angular/core';
import { DatadogService } from './datadog.service';

@Injectable({ providedIn: 'root' })
export class NetworkErrorLoggerService {
  constructor(private datadog: DatadogService) {}

  public init(): void {
    this.setupListeners();
  }

  private setupListeners() {
    // Listen for script loading errors
    window.addEventListener(
      'error',
      (event) => {
        // Check if this is a script loading error
        if (event.target && ((event.target as any).tagName === 'SCRIPT' || (event.target as any).tagName === 'LINK')) {
          this.handleResourceError(event);
        }
      },
      true,
    );
  }

  private handleResourceError(event) {
    const target = event.target;
    const errorInfo = {
      type: 'resource_error',
      resourceType: target.tagName.toLowerCase(),
      url: target.src || target.href,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      message: `Failed to load ${target.tagName.toLowerCase()}: ${target.src || target.href}`,
    };

    this.processError(errorInfo);
  }

  private processError(errorInfo) {
    // Add performance timing data if available
    if (window.performance && window.performance.now) {
      errorInfo.performanceNow = window.performance.now();
    }

    // Add connection information if available
    if (window.navigator && (navigator as any).connection) {
      errorInfo.connectionType = (navigator as any).connection.effectiveType;
      errorInfo.downlink = (navigator as any).connection.downlink;
    }

    this.datadog.error(errorInfo);
  }
}
